import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-paging',
  templateUrl: './paging.component.html',
  styleUrls: ['./paging.component.scss'],
})
export class PagingComponent implements OnInit {
  constructor() {}
  displayPager: number[];
  @Input() currentPage: number;
  @Input() pager: number[];
  @Input() totalPages: number;
  @Output() clickSetPage = new EventEmitter();
  ngOnInit() {
    this.changePage();
  }
  setPage(page: number) {
    this.clickSetPage.emit(page);

    this.changePage();
  }

  changePage() {
    this.displayPager = this.pager.slice(
      Math.max(0, this.currentPage - 5),
      Math.min(this.currentPage + 5, this.totalPages),
    );
  }
}
